import React from "react";
import Navbar from "./global-components/navbar";
import PageHeader from "./global-components/page-header";
import BessSlider from "./shop-components/bess-slider";
import BessDetails from "./shop-components/bess-details";
import Cateogory from "./section-components/category-v2";
import Footer from "./global-components/footer";
import bessData from "../data/bessData";

const IndustrialBess = () => {
  return (
    <div>
      <Navbar />
      <PageHeader
        headertitle={bessData?.name}
        customclass="mb-0"
        Img="inverter.png"
      />
      <BessSlider />
      <BessDetails bess={bessData} />
      <Cateogory features={bessData?.features} />
      <Footer />
    </div>
  );
};

export default IndustrialBess;
